<template>
  <div class="app-config">
    <code-line :title="$t('applications.app_id')" :code="id"></code-line>
    <code-line
      v-if="secret"
      :title="$t('applications.app_secret')"
      :code="secret"
      :is-revealed="isAppSecretRevealed"
      @reveal="isAppSecretRevealed = true"
    ></code-line>
  </div>
</template>

<script>
import CodeLine from "./CodeLine";

export default {
  name: "ApplicationConfig",
  components: {
    CodeLine
  },
  props: {
    id: {
      type: String,
      required: true
    },
    secret: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      isAppSecretRevealed: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.app-config {
  margin-bottom: 1rem;
}
</style>
